export const coins = [
  {
    id: "btc",
    _name: "bitcoin",
    ticker: "BTC",
    cgId: "bitcoin",
  },
  {
    id: "eth",
    _name: "ethereum",
    ticker: "ETH",
    cgId: "ethereum",
  },
  {
    id: "ltc",
    _name: "litecoin",
    ticker: "LTC",
    cgId: "litecoin",
  },
  {
    id: "xrp",
    _name: "ripple",
    ticker: "XRP",
    cgId: "ripple",
  },
  {
    id: "sol",
    _name: "solana",
    ticker: "SOL",
    cgId: "solana",
  },
  {
    id: "usdc",
    _name: "usdc",
    ticker: "USDC",
    cgId: "usd-coin",
  },
  {
    id: "quant",
    _name: "quant",
    ticker: "QNT",
    cgId: "quant-network",
  }
];

export const coinsAbv = {
  bitcoin: "btc",
  ethereum: "eth",
  litecoin: "ltc",
  ripple: "xrp",
  solana: "sol",
  usdc: "usdc",
  quant: "quant",
};
export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,500.99)
});
